// Shared motion presets for the authenticated home page.
// All presets respect prefers-reduced-motion via the prefersReduced flag.

export const prefersReduced =
  typeof window !== "undefined" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

// ─── Card hover/tap ─────────────────────────────────────────────────────────
// Use as: <motion.div {...cardMotion}>
export const cardMotion = prefersReduced
  ? {}
  : {
      whileHover: { y: -3, transition: { duration: 0.2, ease: "easeOut" } },
      whileTap: { scale: 0.985, transition: { duration: 0.1 } },
    };

// A more pronounced lift for larger cards (QuoteCard, CTA cards)
export const cardMotionLarge = prefersReduced
  ? {}
  : {
      whileHover: { y: -4, transition: { duration: 0.25, ease: "easeOut" } },
      whileTap: { scale: 0.98, transition: { duration: 0.1 } },
    };

// For small clickable elements (buttons, chips) — just scale, no lift
export const tapMotion = prefersReduced
  ? {}
  : {
      whileTap: { scale: 0.96, transition: { duration: 0.1 } },
    };

// ─── Scroll-triggered reveal ────────────────────────────────────────────────
// Use as: <motion.div {...scrollReveal}>
export const scrollReveal = prefersReduced
  ? {}
  : {
      initial: { opacity: 0, y: 16 } as const,
      whileInView: { opacity: 1, y: 0 } as const,
      viewport: { once: true, amount: 0.15 } as const,
      transition: { duration: 0.45, ease: [0.25, 0.46, 0.45, 0.94] } as const,
    };
